import * as React from "react";
const SvgItalicicon = (props) => /* @__PURE__ */ React.createElement("svg", { width: "20px", height: "20px", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { id: "layer1" }, /* @__PURE__ */ React.createElement("path", { d: "M 7 4 L 7 5 L 9.9921875 5 L 8 15.955078 L 8 16 L 5 16 L 5 17 L 12 17 L 12 16 L 9.0078125 16 L 11 5.0449219 L 11 5 L 14 5 L 14 4 L 7 4 z ", style: {
  fill: "#222222",
  fillOpacity: 1,
  stroke: "none",
  strokeWidth: 0
} })));
export default SvgItalicicon;
